/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IDialogMessage } from '../components/ami-dialog-message/ami-dialog-message.interface';
import { CrudService } from '../services/crud.service';

@Component({
  template: ''
})
export class SidebarUpdateComponent {
  @Output() close = new EventEmitter<any>();
  @Input() item: any;
  open = true;
  newItem: any;
  changeForm = false;
  readyToStock = false;
  fg: FormGroup;
  message: IDialogMessage;
  constructor(
    @Inject(String) private name: string,
    private service: CrudService
  ) {}

  onClose() {
    this.close.emit();
  }

  async updateItem$(data: any) {
    this.message = { message: `Actualizando ${this.name}` };
    this.message = await this.service.update(this.item.id, data);
    const status = this.message.status;
    if (status === 200) {
      setTimeout(() => {
        this.onClose();
      }, 1500);
    }
  }
}
